var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTablet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m350 502h-320c-11.046 0-20-8.954-20-20v-452c0-11.046 8.954-20 20-20h320c11.046 0 20 8.954 20 20v452c0 11.046-8.954 20-20 20z",
    fill: "#6e83b7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m322 150c-17.645 0-32 14.355-32 32v300c0 7.563 2.643 14.517 7.047 20h52.953c11.046 0 20-8.954 20-20v-332z",
    fill: "#466089"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m-10 70h400v340h-400z",
    fill: "#80d6fb",
    transform: "matrix(0 1 -1 0 430 50)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m360 440v-290h-38c-17.645 0-32 14.355-32 32v258z",
    fill: "#46bee8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m210 481h-40c-5.523 0-10-4.477-10-10 0-5.523 4.477-10 10-10h40c5.523 0 10 4.477 10 10 0 5.523-4.477 10-10 10z",
    fill: "#466089"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m258 466h40v10h-40z",
    fill: "#edeff1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m290 466h8v10h-8z",
    fill: "#d3d3d3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m82 466h40v10h-40z",
    fill: "#edeff1",
    transform: "matrix(-1 0 0 -1 204 942)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 25,
    fill: "#466089",
    r: 10
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 25,
    fill: "#80d6fb",
    r: 7
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m482 502h-160c-11.046 0-20-8.954-20-20v-300c0-11.046 8.954-20 20-20h160c11.046 0 20 8.954 20 20v300c0 11.046-8.954 20-20 20z",
    fill: "#6e83b7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m262 242h280v180h-280z",
    fill: "#80d6fb",
    transform: "matrix(0 1 -1 0 734 -70)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m362 192 6 16h68l6-16z",
    fill: "#6e83b7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 382,
    cy: 184,
    fill: "#466089",
    r: 8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 422,
    cy: 184,
    fill: "#80d6fb",
    r: 8
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablet);
export default __webpack_public_path__ + "static/media/tablet.9e32c52f13ca96890a54cad560b57491.svg";
export { ForwardRef as ReactComponent };